/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SavedPromptRequestField
 */
export interface SavedPromptRequestField {
    /**
     * 
     * @type {string}
     * @memberof SavedPromptRequestField
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SavedPromptRequestField
     */
    value?: string;
}

/**
 * Check if a given object implements the SavedPromptRequestField interface.
 */
export function instanceOfSavedPromptRequestField(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function SavedPromptRequestFieldFromJSON(json: any): SavedPromptRequestField {
    return SavedPromptRequestFieldFromJSONTyped(json, false);
}

export function SavedPromptRequestFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): SavedPromptRequestField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function SavedPromptRequestFieldToJSON(value?: SavedPromptRequestField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'value': value.value,
    };
}

